// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"0f367740","703":"2184d6b7"}[chunkId] + ".chunk.js";
};